(function () {
  'use strict';

  function initShopCategory(section) {
    var columns = Array.prototype.slice.call(section.querySelectorAll('[data-category-column]'));
    var groupsPerColumn = columns.map(function (col) {
      return Array.prototype.slice.call(col.querySelectorAll('[data-group]'));
    });
    var groupCount = groupsPerColumn.length ? groupsPerColumn[0].length : 0;
    if (groupCount === 0) return;

    var duration = parseInt(section.getAttribute('data-rotate-duration'), 10) || 5000;
    var headerFill = section.querySelector('[data-category-progress-fill]');
    var miniFills = Array.prototype.slice.call(section.querySelectorAll('[data-mini-progress-fill]'));
    var prevBtn = section.querySelector('[data-category-prev]');
    var nextBtn = section.querySelector('[data-category-next]');

    var currentGroup = 0;
    var timerId = null;

    // One shared index drives every column at once - there is
    // deliberately no per-column timer or state, so Running,
    // Lifestyle and Sports can never drift out of sync with each
    // other, including across the loop-back to the first group.
    function setActiveGroup(index) {
      currentGroup = ((index % groupCount) + groupCount) % groupCount;
      groupsPerColumn.forEach(function (groups) {
        groups.forEach(function (group, i) {
          group.classList.toggle('is-active', i === currentGroup);
        });
      });
      var percent = ((currentGroup + 1) / groupCount) * 100;
      if (headerFill) headerFill.style.width = percent + '%';
      miniFills.forEach(function (fill) {
        fill.style.width = percent + '%';
      });
    }

    function scheduleNext() {
      clearTimeout(timerId);
      timerId = setTimeout(function () {
        setActiveGroup(currentGroup + 1);
        scheduleNext();
      }, duration);
    }

    function goTo(index) {
      setActiveGroup(index);
      scheduleNext();
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(currentGroup + 1);
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(currentGroup - 1);
      });
    }

    setActiveGroup(0);
    scheduleNext();
  }

  // Quick add - same real Ajax Cart API call used elsewhere in this
  // theme's own custom sections (assets/collection-grid.js), scoped
  // to this section's own buttons only.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-shop-category-quick-add]');
    if (!button) return;
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.disabled) return;

    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Could not add to cart');
        return res.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:open'));
      })
      .catch(function (err) {
        console.error(err);
      })
      .finally(function () {
        button.disabled = false;
      });
  });

  document.querySelectorAll('[data-shop-category]').forEach(initShopCategory);
})();
